module.exports = __webpack_public_path__ + "static/media/arrow-back.235c3d90.svg";